// /ontology — admin-gated Object Type editor page.

import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useRole } from "@/hooks/useRole";
import { useObjectTypes } from "@/hooks/useObjectTypes";
import { PageHeader } from "@/components/layout/PageHeader";
import { ObjectTypeList } from "@/components/ontology/ObjectTypeList";
import { ObjectTypeEditor } from "@/components/ontology/ObjectTypeEditor";

export default function OntologyPage() {
  const { isAdmin, isLoading: isRoleLoading } = useRole();
  const { objectTypes, isLoading } = useObjectTypes();

  // null = new object type mode; string = editing existing by ID
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (isRoleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="w-full h-[calc(100vh-4rem)] flex flex-col">
      <PageHeader title="Ontology" subtitle="Define object types and their property schemas." />

      <div className="flex-1 min-h-0 flex overflow-hidden">
        {/* Left rail — object type list */}
        <aside className="w-72 flex-shrink-0 border-r border-border glass-panel overflow-hidden">
          <ObjectTypeList
            objectTypes={objectTypes}
            isLoading={isLoading}
            selectedId={selectedId}
            onSelect={setSelectedId}
          />
        </aside>

        {/* Right pane — editor */}
        <div className="flex-1 min-w-0 overflow-hidden flex flex-col">
          <ObjectTypeEditor selectedId={selectedId} onCreated={(id) => setSelectedId(id)} />
        </div>
      </div>
    </main>
  );
}
